import styled from '@emotion/styled';
import { H3, SmallText, Text } from 'ds/components/typography';
import { typographyLineHeightCfg } from 'ds/components/typography/types';
import { FormFieldMode } from './Fields';
import { colorToAlpha } from 'helpers/insight';

export const SectionForm = styled.div`
  width: 100%;
`;

export const Title = styled(SmallText)`
  white-space: pre-wrap;
  line-height: ${typographyLineHeightCfg.text}px;
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey2};
    margin-bottom: ${theme.spacing(1)};
  `}
`;

export const FormTitle = styled(H3)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(2.5)};
`;

export const FormWrapper = styled.div<{ mode: FormFieldMode; inModal?: boolean; }>`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  grid-template-columns: ${({ mode }) => mode === FormFieldMode.Column ? '1fr' : '1fr 1fr'};
  .textfield-input {
    background: ${({ theme }) => theme.colors.neutrals.grey11};
    padding-right: ${({ theme }) => theme.spacing(1.5)};
    padding-left: ${({ theme }) => theme.spacing(4)};
  }
  && .textfield-icon {
    right: auto;
    left: 8px;
    svg {
      path {
        fill: ${({ theme }) => theme.colors.neutrals.grey1};
      }
    }
  }
  ${({ theme, inModal }) => inModal && theme.media.showAt({ at: 1 })`
    gap: ${theme.spacing(3)};
  `}
`;

export const SuccessWrapper = styled.div<{ inModal?: boolean; isRowMode: boolean; }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  ${({ theme, inModal, isRowMode }) => inModal || !isRowMode ? `
    gap: 30px;
    padding-top: ${theme.spacing(3)};
    padding-bottom: ${theme.spacing(3)};
    width: 100%;
    border-radius: ${theme.borderRadius.small};
    border: ${inModal ? '0 none' : `1px solid ${theme.colors.neutrals.grey8}`};
    margin-top: ${inModal ? theme.spacing(1) : 0};
    margin-bottom: ${inModal ? theme.spacing(3) : 0};
  ` : ''}
`;

export const SuccessMessage = styled(Text)`
  max-width: 164px;
  text-align: center;
`;

export const ButtonWrapper = styled.div<{ inModal?: boolean }>`
  ${({ theme, inModal }) => inModal && theme.media.showAt({ at: 1 })`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: ${theme.spacing(1)} ${theme.spacing(3)};
    box-shadow: 0 -4px 10px 0 ${colorToAlpha(theme.colors.neutrals.black, 0.05)};
  `}
`;

export const SuccessButtonWrapper = styled(ButtonWrapper)`
  position: static;
`;
